export default function (window) {
	const interval = (fn, milliseconds) => {
		const id = window.setInterval(fn, milliseconds);
		return { id };
	};
	interval.cancel = (promise) => {
		if (promise) {
			window.clearInterval(promise.id);
		}
	};

	return interval;
}
